import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {Report} from '../../../model';
import {InputType} from '../../../model/enums/input.type';

@Component({
  selector: 'app-duplicate-report',
  templateUrl: './duplicate-report.modal.html',
  styleUrls: ['./duplicate-report.modal.scss']
})
export class DuplicateReportModal implements OnInit {

  subject: Subject<any>;
  subscription: any;
  report: Report = new Report();
  typeOfInput = InputType;
  maxlength = 250;
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService) {
    this.report = this.modalService.config['report'];
  }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  onConfirm(): void {
    this.bsModalRef.hide();
    this.subject.next({
      ACCEPT: true,
      ENTITIES: this.report.ENTITIES,
      INTERNAL_FILE_NAME: this.report.INTERNAL_FILE_NAME,
    });
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next({
      ACCEPT: false
    });
    this.subject.complete();
  }

}
